<template>
    <HamletTable
        :columns="columns"
        :fetch="fetch"
        @onRowClick="edit"
    >
        <template #header-label>
            {{ $t('Page(UserInterface):Component(Text):page-label') }}
        </template>

        <template #header-controls>
            <Button v-if="$can('visit', 'system-security-user-interface-create')" @click="$router.push({name: 'system-security-user-interface-create'})" class="btn-icon">
                <feather-icon icon="PlusIcon" />
            </Button>
        </template>

        <template #cell-applications="data">
            <b-badge v-for="app in data.item.applications" class="mr-50" variant="primary">{{ app }}</b-badge>
        </template>

        <template #cell-service="data">
            {{ data.item.services.map(s => s.title).join(', ') }}
        </template>
    </HamletTable>
</template>
<script>
import {BBadge} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {SystemApi} from "@core/api";
import {Button} from "@core/components/common";

export default {
    components: {HamletTable, Button, BBadge},
    data() {
        return {
            columns: [
                {
                    key: 'id',
                    label: this.$t('Component(Grid):column-id')
                },
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'applications',
                    label: this.$t('Component(Grid):column-applications')
                },
                {
                    key: 'type',
                    label: this.$t('Component(Grid):column-type')
                },
                {
                    key: 'service',
                    label: this.$t('Component(Grid):column-service')
                },
                {
                    key: 'attributes',
                    label: this.$t('Component(Grid):column-attributes')
                },
            ]
        }
    },
    methods: {
        fetch(config, cb) {
            SystemApi.security.getUserInterfaces([], {}, config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        },
        edit(ui) {
            console.log(ui);
            if (this.$can('visit', 'system-security-user-interface-card')) {
                console.log('sdf')
                this.$router.push({
                    name: 'system-security-user-interface-card',
                    params: {id: ui.id}
                })
            }
        },
    }
};
</script>
